import { Outlet, Navigate } from "react-router-dom";

interface childsProps {
  restablecer :boolean
}
//Ruta protegida para que solo los usuarios que tengan el estado "P" puedan acceder a esta sección (sin importar si están logeados o no)
const RestablecerRoute: React.FC<childsProps> = ({restablecer}) => {  
  if (restablecer === false) {
    return <Navigate to="App/login" />;
  }

  return <Outlet />;
};

export default RestablecerRoute;